// @flow

//
// React
//
import React, { type Node } from 'react';

//
// Components
//
import {
    TextFloatPaneField,
} from '../../../trix-web-components-pane';

//
// Props
//
type Props = {
    //
    // State
    //
    label: string,

    //
    // Data
    //
    data: any,
}; // End of Props

//
// Component
//
const WarehouseFloatPaneField = (props: Props): Node => {
    const warehouseName = (props.data && props.data.name) ? props.data.name : '';

    return (
        <TextFloatPaneField
            label={props.label}
            value={warehouseName}
        />
    );
};
export default WarehouseFloatPaneField;
